import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ROUTE_VEHICLES } from '../../utils/routingConstants'
import { VehiclesView } from '../../components'
import { Grid, Col, Row } from 'react-bootstrap'
import { GA_PAGES } from '../../api/gaHelper'
import { page } from '../../hocs/page'

class PageGarage extends Component {
  render () {
    const { userSession } = this.props
    return (
      <Row>
        <Col md={1} />
        <Col md={10}>
          <Grid fluid>
            <VehiclesView title='Vehicles' validRelationships={userSession.isAnonymous ? ['public'] : ['mine', 'public']} publicOnly={userSession.isAnonymous} />
          </Grid>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return { userSession: state.session }
}

export default page(connect(mapStateToProps)(PageGarage), { pageView: GA_PAGES.VEHICLES, uiNavigationRoute: ROUTE_VEHICLES })
